import { useRef, useEffect, useCallback } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
var OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT = 100;
export function useNotificationDropdownHover(_a) {
    var isNotificationsDropdownOpen = _a.isNotificationsDropdownOpen, openNotificationsDropdown = _a.openNotificationsDropdown, closeNotificationsDropdown = _a.closeNotificationsDropdown, enterNotificationsIcon = _a.enterNotificationsIcon;
    var openNotificationsDropdownTimerId = useRef();
    var closeNotificationsDropdownTimerId = useRef();
    var noDropdown = useFlag('nc_no_dropdown');
    var handleNotificationsDropdownHover = useCallback(function () {
        openNotificationsDropdownTimerId.current = setTimeout(noDropdown ? enterNotificationsIcon : openNotificationsDropdown, OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT);
        clearTimeout(closeNotificationsDropdownTimerId.current);
    }, [noDropdown, enterNotificationsIcon, openNotificationsDropdown]);
    var handleNotificationsDropdownLeave = useCallback(function () {
        if (!noDropdown) {
            clearTimeout(openNotificationsDropdownTimerId.current);
            closeNotificationsDropdown();
        }
    }, [noDropdown, closeNotificationsDropdown]);
    var handleNotificationsDropdownTouch = useCallback(function (e) {
        if (!isNotificationsDropdownOpen) {
            // default actions should only be prevented for the initial click
            // once the notification menu is shown, we want to let other touch
            // events pass through
            e.preventDefault();
        }
        handleNotificationsDropdownHover();
    }, [handleNotificationsDropdownHover, isNotificationsDropdownOpen]);
    useEffect(function () {
        return function () {
            clearTimeout(openNotificationsDropdownTimerId.current);
            // TODO: I'm not entirely sure why the linter hates this particular line...
            // eslint-disable-next-line react-hooks/exhaustive-deps
            clearTimeout(closeNotificationsDropdownTimerId.current);
        };
    }, []);
    return {
        handleNotificationsDropdownHover: handleNotificationsDropdownHover,
        handleNotificationsDropdownLeave: handleNotificationsDropdownLeave,
        handleNotificationsDropdownTouch: handleNotificationsDropdownTouch,
    };
}
//# sourceMappingURL=useNotificationDropdownHover.js.map